var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/core-js/modules/_shared-key.js
// module id = ../../../../core-js/modules/_shared-key.js
// module chunks = 1